import { Component, Input, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-banner',
  templateUrl: './banner.component.html',
  styleUrls: ['./banner.component.css']
})
export class BannerComponent implements OnInit {

  url = environment.apibase

  @Input() imgGrande
  @Input() imgMediana
  @Input() imgPequena

  constructor() { }

  ngOnInit() {
  }

}
